(function () {
  'use strict';

  // The Kaktus drawer renders inside a same-origin iframe the theme's CSS never reaches, and it
  // rebuilds its markup on every cart change — so the row and its styles are written into the
  // drawer's own document and re-added whenever the drawer drops them.

  var config = window.BELLO_CART_PROMO;
  if (!config || !config.text) return;

  // The row only shows during an offer period (Theme settings → Bello offer), with that period's label.
  function activePeriod() {
    var periods = window.BELLO_PERIODS || {};
    var now = window.belloNow ? window.belloNow() : Date.now() / 1000;
    for (var p = 1; p <= 5; p++) {
      var w = periods[p];
      if (w && now >= w[0] && now < w[1]) return String(p);
    }
    return null;
  }

  var ROW = 'bello-cart-promo';
  var STYLE_ID = 'bello-cart-promo-style';
  var CSS =
    "@font-face{font-family:'BelloCartPromoBold';src:url('" + config.boldFont + "') format('woff2');font-weight:400;font-display:swap}" +
    '.' + ROW + '{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:8px;padding:10px 10px 9px;' +
    'border-bottom:1px solid #f2e9db;background:linear-gradient(rgba(164,210,51,0.1),rgba(164,210,51,0.1)),#fff;' +
    'box-shadow:0 4px 12px rgba(58,74,47,0.02);color:#5b6b4f;text-align:center;' +
    "font-family:'Moderat-Thin',sans-serif;font-size:16px;font-weight:400;line-height:1.4}" +
    '.' + ROW + ' p{margin:0}' +
    '.' + ROW + '__label{display:inline-flex;align-items:center;padding:6px 12px;border-radius:100px;background:#597012;color:#fff;' +
    "font-family:'EightiesComeback-Light',serif;font-size:14px;font-weight:400;line-height:11px;text-transform:uppercase}" +
    '.' + ROW + " strong{font-family:'BelloCartPromoBold','Moderat-Thin',sans-serif;font-weight:400}" +
    '.' + ROW + ' a{color:inherit;text-decoration:underline;text-underline-offset:2px}' +
    '.' + ROW + ' a:focus-visible{outline:2px solid #597012;outline-offset:2px}';

  function docs() {
    var out = [];
    function add(w) {
      if (!w) return;
      var d;
      try { d = w.document; } catch (e) { return; }
      if (!d || out.indexOf(d) !== -1) return;
      out.push(d);
      var frames;
      try { frames = w.frames; } catch (e) { frames = null; }
      if (frames) {
        for (var i = 0; i < frames.length; i++) {
          try { add(frames[i]); } catch (e) {}
        }
      }
    }
    add(window);
    return out;
  }

  function build(doc, period) {
    var row = doc.createElement('div');
    row.className = ROW;
    row.setAttribute('data-period', period);
    var labelText = config.labels && config.labels[period];
    if (labelText) {
      var label = doc.createElement('p');
      label.className = ROW + '__label';
      label.textContent = labelText;
      row.appendChild(label);
    }
    var text = doc.createElement('p');
    text.innerHTML = config.text;
    row.appendChild(text);
    return row;
  }

  function inject(doc, period) {
    var products = doc.querySelector('.kaktusc-cart__products');
    if (!products) return;

    var anchor = doc.querySelector('.kaktusc-cart__timer-wrap');
    var parent = anchor ? anchor.parentNode : products.parentNode;
    var existing = parent.querySelector(':scope > .' + ROW);
    if (!period) {
      if (existing) existing.remove();
      return;
    }
    var inPlace = existing && existing.getAttribute('data-period') === period &&
      (anchor ? existing.previousElementSibling === anchor : existing.nextElementSibling === products);
    if (inPlace) return;
    if (existing) existing.remove();

    if (!doc.getElementById(STYLE_ID)) {
      var style = doc.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      (doc.head || doc.documentElement).appendChild(style);
    }
    parent.insertBefore(build(doc, period), anchor ? anchor.nextSibling : products);
  }

  function tick() {
    var period = activePeriod();
    docs().forEach(function (d) {
      try { inject(d, period); } catch (e) {}
    });
  }

  setInterval(tick, 400);
  tick();
})();
